import { Redirect, Route, useRouteMatch } from "react-router-dom";
import useUser from "../hooks/useUser";
import useOrganisation from "../hooks/useOrganisation";
import { Integrations } from "../util/constants";
import RoleGate from "./FeatureGate/RoleGate";
import AccessDenied from "./AccessDenied";

const ProtectedRoute = ({
  component,
  render,
  allowedWithoutTotp,
  requiredRoles = [],
  ...rest
}) => {
  const { hasConfirmedDetails, ShortCode, accountingSoftware, Subsidiaries } =
    useOrganisation(null, {
      suspense: false,
    });

  const { isLoggedIn } = useUser();

  const isOnConfirmationExemptRoute = useRouteMatch({
    path: [
      "/",
      "/dashboard",
      "/connect",
      "/receivables",
      "/receivables/dashboard",
    ],
    exact: true,
  });

  const requiresSubsidiarySelection =
    accountingSoftware === Integrations.NETSUITE &&
    Subsidiaries.length > 1 &&
    !Subsidiaries.some(({ enabled }) => enabled);

  const Component = component;

  return (
    <Route
      {...rest}
      render={(routeProps) => {
        if (
          ShortCode &&
          isLoggedIn &&
          !hasConfirmedDetails &&
          !isOnConfirmationExemptRoute
        ) {
          return <Redirect to="/" />;
        }

        if (ShortCode && isLoggedIn && requiresSubsidiarySelection) {
          return (
            <Redirect
              to={`/select-organisations/netsuite?organisation=${ShortCode}`}
            />
          );
        }

        if (isLoggedIn) {
          if (requiredRoles.length === 0) {
            return render ? render(routeProps) : <Component {...routeProps} />;
          }

          return (
            <RoleGate
              roles={requiredRoles}
              renderGate={<AccessDenied requiredRoles={requiredRoles} />}
            >
              {render ? render(routeProps) : <Component {...routeProps} />}
            </RoleGate>
          );
        }
        return (
          <Redirect
            to={{
              pathname: "/login",
              state: {
                from: routeProps.location,
              },
            }}
          />
        );
      }}
    />
  );
};

export default ProtectedRoute;
